module.exports = __webpack_public_path__ + "img/privilege13.b7394065.png";